<template>
    <div class="progress">
        <slot />
        <div
            :aria-valuemin="min"
            :aria-valuemax="max"
            :aria-valuenow="value"
            :aria-label="label"
            :style="{ backgroundColor: _color, width: width && `${width}%` }"
            class="progress-bar"
            role="progressbar"
        >
            <div
                v-if="$slots.default"
                class="progress-bar-slot"
                :style="{ width: `${component.width}px` }"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { useResponsive, getElement } from '@/store/responsive';

export default {
    name: 'ProgressBar',
    props: {
        color: { type: String, default: null },
        colorClass: { type: String, default: 'theme', options: 'colourClass' },
        min: { type: Number, default: 0 },
        max: { type: Number, default: 100 },
        value: { type: Number, default: 0 },
        label: { type: String, default: null }
    },
    slots: ['default'],
    computed: {
        component() {
            return getElement(this);
        },
        _color() {
            if (this.color) return this.color;
            return this.$window.colours[this.colorClass];
        },
        width() {
            return (this.value - this.min) / (this.max - this.min) * 100;
        }
    },
    mounted() {
        useResponsive(this, this.$el);
    },
    beforeUnmount() {
        useResponsive.removeElement(this);
    },
};
</script>

<style lang="less" scoped>
.progress {
    --default-progress-background-colour: var(--mercury);
    position: relative;
    height: 6px;
    border-radius: var(--progress-border-radius, 6px);
    margin: 0;
    background-color: var(--progress-background-colour, var(--default-progress-background-colour));
    overflow: hidden;
    text-align: center;
    .progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        height: 100%;
        border-radius: var(--progress-bar-border-radius, 6px);
        transition: var(--smooth);
        color: #FFF;
        .progress-bar-slot {
            text-align: center;
        }
    }
}
</style>
